import axios from "axios";

// Create Axios instance
const API = axios.create({
  baseURL: "https://app.essentialanchor.com/api/api/",
  withCredentials: true, 
});

// Request Interceptor - Attach Access Token
API.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("accessToken"); // Get stored token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor - Refresh Token if Expired
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      try {
        // Try refreshing the token
        const refreshResponse = await axios.post(
          `https://app.essentialanchor.com/api/api/refresh`,
          {},
          { withCredentials: true }
        );

        const newAccessToken = refreshResponse.data.accessToken;
        localStorage.setItem("accessToken", newAccessToken);
        // Retry the original request with the new token
        error.config.headers.Authorization = `Bearer ${newAccessToken}`;
        return API(error.config);
      } catch (refreshError) {
        console.error("Refresh token failed:", refreshError);
        localStorage.removeItem("accessToken");
      }
    }

    return Promise.reject(error);
  }
);

export default API;
